import { ISelectOption, ISelectProps, Select } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { useCostCodeGroup } from 'hooks';
import { useEffect, useState } from 'react';
import { ALL_GROUPS, NO_GROUP } from 'utils/constants/stringConstants';
import { t } from 'utils/localize';

export interface ICostCodeGroupSelectProps extends Omit<ISelectProps, 'options'> {
  includeAllCostCodes: boolean;
  includeNoCostCodes: boolean;
  className?: string | object;
}

const CostCodeGroupSelect = (props: ICostCodeGroupSelectProps) => {
  const { includeAllCostCodes, includeNoCostCodes, className, ...selectProps } = props;

  const [options, setOptions] = useState<ISelectOption[]>([{ label: t('All Cost Codes'), value: ALL_GROUPS }]);
  const costCodeGroupActions = useCostCodeGroup();

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [includeAllCostCodes, includeNoCostCodes]);

  async function getData() {
    const data = await costCodeGroupActions.getCostCodeGroups(null);

    if (data) {
      const opts = [];

      if (includeAllCostCodes) {
        opts.push({ label: t('All Cost Codes'), value: ALL_GROUPS });
      }

      opts.push(...data.map((group) => ({ value: group.id, label: group.groupName })));

      if (includeNoCostCodes) {
        opts.push({ label: t('No Group'), value: NO_GROUP });
      }

      setOptions(opts);
    }
  }

  const classes = classNames('group-picker', className);

  return <Select {...selectProps} options={options} className={classes} />;
};

CostCodeGroupSelect.defaultProps = {
  ...Select.defaultProps,
  includeAllCostCodes: true,
  includeNoCostCodes: true,
};

export default CostCodeGroupSelect;
